import store from '@/store'

/**
 * @param {Array} value
 * @returns {Boolean}
 */
export default function hasFeatures (value) {
  if (value && value instanceof Array && value.length > 0) {
    const features = store.getters && store.getters.appFeatures
    const checkedFeatures = value

    const hasFeature = features.some(role => {
      return checkedFeatures.includes(role)
    })

    if (!hasFeature) {
      return false
    }
    return true
  } else {
    console.error(`need features! Like hasFeatures="['admin','editor']"`)
    return false
  }
}
